import defaultAxiosClient from ".";
import { Client } from "./generated";

const getBaseUrl = (envBaseUrl: string | undefined) => {
    let result = envBaseUrl?.replace("/api", "");
    result = envBaseUrl === "api" ? "" : result;
    if (result === "") {
        result = window.location.origin;
    }
    return result;
};

export default new Client(getBaseUrl(process.env.REACT_APP_API_BASE_URL), defaultAxiosClient);
